import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store";
import { Provider } from "react-redux";
import { clientId, domain } from "./constants";
import { CMSProvider } from "domains/Cms/cmsContext";

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <CMSProvider>
        <App />,
      </CMSProvider>
    </React.StrictMode>
  </Provider>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
